import { combineReducers } from 'redux';
import loginReducer from './LoginReducer';
import portofolioReducer from './PortofolioReducer';
import commonReducer from './CommonReducer';
import userPortofolioReducer from './UserPortofolioReducer';
import changePasswordReducer from './ChangePasswordReducer';
import transactionHistoryReducer from './TransactionHistoryReducer';
import forgotPasswordReducer from './ForgotPasswordReducer';
import marketplaceListReducer from './MarketplaceListReducer';
import fundingReducer from './FundingReducer';
import navHeaderReducer from './NavHeaderReducer';
import withdrawReducer from './WIthdrawReducer';
import coorporateProfile from './CoorporateProfileReducer';
import loanTypeReducer from './LoanTypeReducer';

export default combineReducers({
	commonReducer,
	loginReducer,
	portofolioReducer,
	userPortofolioReducer,
	changePasswordReducer,
	transactionHistoryReducer,
	forgotPasswordReducer,
	marketplaceListReducer,
	fundingReducer,
	navHeaderReducer,
    withdrawReducer,
	coorporateProfile,
	loanTypeReducer
});
